import { connect } from 'react-redux';

import { homeActions } from 'dataflow/billingPortal/actions';

import { HomePresentation } from './HomePresentation';

function mapStateToProps(state) {
    const { 
        getOneClickActionDetails_requesting, 
        oneClickActionDetails,

        generateAllUnbilledInvoices_requesting,
        generateAllUnbilledInvoices_status, 

        generateAllUnbilledAdvancePayInvoices_requesting,
        generateAllUnbilledAdvancePayInvoices_status,

        postAllUnpostedInvoicesToSqlAccount_requesting,
        postAllUnpostedInvoicesToSqlAccount_status, 

        sendAllPendingInvoices_requesting,
        sendAllPendingInvoices_status,

        getInvoiceDetailList_requesting, 
        invoiceDetailList, 
        invoiceDetailListHeaders ,

        generateCompareUnpostedInvoices_requesting,
        compareUnpostedInvoices
    } = state.homeReducers;

    const { userPermissions } = state.userManagementReducers;

	return {
        getOneClickActionDetails_requesting, 
        oneClickActionDetails,

        generateAllUnbilledInvoices_requesting,
        generateAllUnbilledInvoices_status, 

        generateAllUnbilledAdvancePayInvoices_requesting,
        generateAllUnbilledAdvancePayInvoices_status,

        postAllUnpostedInvoicesToSqlAccount_requesting,
        postAllUnpostedInvoicesToSqlAccount_status, 

        sendAllPendingInvoices_requesting,
        sendAllPendingInvoices_status,

        getInvoiceDetailList_requesting, 
        invoiceDetailList, 
        invoiceDetailListHeaders,

        generateCompareUnpostedInvoices_requesting,
        compareUnpostedInvoices,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getOneClickActionDetails: (paramObj) => { dispatch(homeActions.getOneClickActionDetails(paramObj)); },
        getTableDetails: (pageNo, pageSize, sort, filterOptions) => { dispatch(homeActions.getInvoiceDetailList(pageNo, pageSize, sort, filterOptions)); },

        generateAllUnbilledInvoices: (endDate) => { dispatch(homeActions.generateAllUnbilledInvoices(endDate)); },
        generateAllUnbilledAdvancePayInvoices: (endDate) => { dispatch(homeActions.generateAllUnbilledAdvancePayInvoices(endDate)); },
        postAllUnpostedInvoicesToSqlAccount: () => { dispatch(homeActions.postAllUnpostedInvoicesToSqlAccount()); },
        sendAllPendingInvoices: (isSentToCustomers) => { dispatch(homeActions.sendAllPendingInvoices(isSentToCustomers)); },
        generateCompareUnpostedInvoices: () => { dispatch(homeActions.generateCompareUnpostedInvoices()); },
    };
}

const Home = connect(mapStateToProps, mapDispatchToProps)(HomePresentation);

export default Home;